import { SVGProps } from 'react';

const NewsIcon = ({
  height = '24px',
  width = '24px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    {...props}
  >
    <g id='ic-layout-footer'>
      <rect
        id='Rectangle_67'
        data-name='Rectangle 67'
        width='20'
        height='20'
        rx='2'
        transform='translate(22 22) rotate(180)'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </g>
    <line
      id='Line_568'
      data-name='Line 568'
      x2='13'
      transform='translate(6 6)'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <line
      id='Line_569'
      data-name='Line 569'
      x2='4'
      transform='translate(14 10)'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <line
      id='Line_570'
      data-name='Line 570'
      x2='4'
      transform='translate(14 14)'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <line
      id='Line_571'
      data-name='Line 571'
      x2='13'
      transform='translate(6 18)'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <rect
      id='Rectangle_16976'
      data-name='Rectangle 16976'
      width='5'
      height='5'
      rx='1'
      transform='translate(6 9)'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>
);

export default NewsIcon;
